<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-10">
			<!-- Empty car-->
				<section class="account-section">
					<h2>Solicitar Factura</h2>
					<form class="form-horizontal col-sm-8 request-invoice" @submit="requestInvoice">
						<div class="row form-group">
							<p class="col-sm-9 col-sm-offset-3 legend-custom">Datos de Facturación</p>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="business-name">Nombre o razón social*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.business_name}" v-model="render_billing_info.business_name"/>
								<div class="tooltip-error" v-if="err.business_name">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa la razón social de tu empresa para continuar.
						      	</div>
						      	<div class="tooltip-error" v-if="err.business_name_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.business_name_msg }}
						      	</div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="street">Calle*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.street }" v-model="render_billing_info.street"/>
								<div class="tooltip-error" v-if="err.street">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa la calle de tu empresa para continuar.
				        		</div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="ext">N° Ext.*</label>
							<div class="col-sm-3">
								<input type="text" class="form-control" :class="{ 'has-error': err.ext_number }" v-model="render_billing_info.ext_number"/>
							</div>
							<label class="control-label col-sm-3" for="ext">N° Int.</label>
							<div class="col-sm-3">
								<input type="text" class="form-control" :class="{ 'has-error': err.int_number }" v-model="render_billing_info.int_number"/>
								<div class="tooltip-error" v-if="err.ext_number">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa el número exterior de tu empresa para continuar.
				        		</div>
							</div>
						</div>
						
						<div class="row form-group">
							<label class="control-label col-sm-3" for="suburb">Colonia*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.suburb }" v-model="render_billing_info.suburb"/>
								<div class="tooltip-error" v-if="err.suburb">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa la colonia de tu empresa para continuar.
				        		</div>
				        		<div class="tooltip-error" v-if="err.suburb_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.suburb_msg }}
						      	</div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="zip-code">C.P.*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.postal_code }" v-model="render_billing_info.postal_code"/>
								<div class="tooltip-error" v-if="err.postal_code">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa el código postal de tu empresa para continuar.
						      	</div>
						      	<div class="tooltip-error" v-if="err.postal_code_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.postal_code_msg }}
						      	</div>
							</div>
						</div>

						<div class="row form-group">
							<label class="control-label col-sm-3">Estado</label>
							<div class="col-sm-9">
								<select class="form-control" :class="{ 'has-error': err.state_id }" v-model="render_billing_info.state_id" @change="addCities(render_billing_info.state_id)">
									<option value="" disabled>Selecciona un estado</option>
									<option v-for="state in render_states" :value="state.id">{{ state.nom_ent }}</option>
								</select>
								<div class="tooltip-error" v-if="err.state_id">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa el estado de tu empresa para continuar.
				        		</div>
				        		<div class="tooltip-error" v-if="err.state_id_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.state_id_msg }}
						      	</div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3">Ciudad</label>
							<div class="col-sm-9">
								<select class="form-control" :class="{ 'has-error': err.city_id }" v-model="render_billing_info.city_id" id="city">
								  	<option value="" disabled>Seleccionar primero un estado</option>
								  	<option v-for="city in render_cities" :value="city.id">{{ city.nom_mun }}</option>
								</select>
								<div class="tooltip-error" v-if="err.city_id">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa la ciudad de tu empresa para continuar.
				        		</div>
				        		<div class="tooltip-error" v-if="err.city_id_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.city_id_msg }}
						      	</div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="rfc">RFC*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.rfc }" v-model="render_billing_info.rfc"/>
								<div class="tooltip-error" v-if="err.rfc">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa el RFC de tu empresa para continuar.
						      	</div>
						      	<div class="tooltip-error" v-if="err.rfc_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.rfc_msg }}
						      	</div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="phone2">Teléfono*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.phone_number }" v-model="render_billing_info.phone_number"/>
								<div class="tooltip-error" v-if="err.phone_number">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa el número de teléfono de tu empresa para continuar.
				        		</div>
				        		<div class="tooltip-error" v-if="err.phone_number_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.phone_number_msg }}
						      	</div>
							</div>
						</div>
						<!-- <div class="row form-group">
							<label class="control-label col-sm-3" for="email2">Email*</label>
							<div class="col-sm-9">
								<input type="text" class="form-control" :class="{ 'has-error': err.email }" v-model="render_billing_info.email"/>
								<div class="tooltip-error" v-if="err.email">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa el email de tu empresa para continuar.
				        		</div>
				        		<div class="tooltip-error" v-if="err.email_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.email_msg }}
						      	</div>
							</div>
						</div> -->

						<div class="row form-group">
							<div class="col-sm-9 pull-right no-padding">
								<button type="submit" class="btn btn-black btn-lg">	Solicitar factura
									</button>
							</div>
						</div>
					</form>
				</section>
			</div>
		</div>
	</div>
	
	<loader-full v-if="is_submited"></loader-full>
</template>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import LoaderFull from '../../components/Loader-full.vue';
import API from '../../store/api';
import { addCities } from '../../store/actions';
import { router } from '../../routes/routes';

const form = {
	business_name: '',
	street: '',
	ext_number: '',
	int_number: '',
	suburb: '',
	postal_code: '',
	city_id: '',
	state_id: '',
	phone_number: '',
	rfc: '',
	// email: '',
};

// ---- REGEX INFO ----
var string_regexp = new RegExp(/[^\s0-9]+(\s+[^\s]+)*$/);
var number_regexp = new RegExp(/^\d/);
var phone_regexp = new RegExp(/^\d{10}$/);
var birthday_regexp = new RegExp(/^\d{2}/);
var email_regexp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
var rfc_regexp = new RegExp(/^[A-Za-z]{3,4}\-{0,1}\d{6}(?:\-{0,1}[A-Za-z\d]{3})?$/);
var alphanumeric_regexp = new RegExp(/[^\s#°]+(\s+[^\s]+)*$/);
var postal_code_regexp = new RegExp(/^\d{5}$/);

export default {
	data () {
		return {
			has_error: false,
			error_msg: '',
			err: {},
			is_submited: false,
			form
		}
	},

	vuex: {
		getters: {
			user: state => state.current_user,
			states: state => state.states,
			cities: state => state.cities,
			rfc_billing_info: state => state.rfc_billing_info
		},
		actions: {
			addCities
		}
	},

	computed: {
		render_cities () {
			return this.cities;
		},

		render_states () {
			return this.states;
		},

		render_billing_info () {
			this.addCities(this.rfc_billing_info.state_id);
			return this.rfc_billing_info;
		}
	},

	methods: {
		requestInvoice (e) {
			e.preventDefault();

			this.has_error = false;
			this.err = {}
			this.error_msg = '';

			let form = {
				business_name: this.rfc_billing_info.business_name,
				street: this.rfc_billing_info.street,
				ext_number: this.rfc_billing_info.ext_number,
				int_number: this.rfc_billing_info.int_number,
				suburb: this.rfc_billing_info.suburb,
				postal_code: this.rfc_billing_info.postal_code,
				state: this.rfc_billing_info.state_id,
				city: this.rfc_billing_info.city_id,
				rfc: this.rfc_billing_info.rfc,
				phone_number: this.rfc_billing_info.phone_number,
				// email: this.rfc_billing_info.email,
			};

			this.validateInvoice(form);

			$(window).resize( function(){
				if ($(window).width()<778){
					setTimeout( function(){
						$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
						$(".top-caret").css({"display": "none"});
						$(".tooltip-error").addClass("center-block");
					}, 10);
				}else{
					setTimeout( function(){
						$(".tooltip-error").css({"position": "absolute", "margin-top" : "0"});
						$(".top-caret").css({"display": "block"});
						$(".tooltip-error").addClass("center-block");
					}, 10);
				}
			});

			if(this.has_error){
				return
			}

			this.is_submited = true;

			API.BillingInfo.invoice(
				this.user,
				this.$route.params.id,
				form,
				this
			);
		},

		validateInvoice(form){
			for (let k in form) {
				if (!form[k] && k != 'int_number') {
					this.has_error = true;
					this.err[k] = true;
				}
			}
			
			if (form.business_name.length < 5){
				this.has_error = true;
				this.err.business_name_msg = 'El nombre o razón social debe tener más de 5 caracteres.';
			}

			if (!form.suburb.match(string_regexp) && !this.err.suburb){
				this.has_error = true;
				this.err.suburb_msg = 'Ingresa únicamente letras para continuar.';
			}

			if (!form.postal_code.match(postal_code_regexp) && !this.err.postal_code){
				this.has_error = true;
				this.err.postal_code_msg = 'Ingresa un código postal válido para continuar.';
			}
			if (!form.rfc.match(rfc_regexp) && !this.err.rfc){
				this.has_error = true;
				this.err.rfc_msg = 'Ingresa un RFC válido para continuar.';
			}
			if (!form.phone_number.match(phone_regexp) && !this.err.phone_number){
				this.has_error = true;
				this.err.phone_number_msg = 'Ingresa tu número a 10 dígitos para continuar.';
			}
			// if (!form.email.match(email_regexp) && !this.err.email){
			// 	this.has_error = true;
			// 	this.err.email_msg = 'Ingresa un correo electrónico válido para continuar.';
			// }
			if (!form.int_number.match(string_regexp) && form.int_number){
				this.has_error = true;
				this.err.int_number_msg = 'Ingresa únicamente letras y números para continuar.';
			}
		}
	},

	components: {
		Breadcrumb,
		Sidebar,
		LoaderFull
	}
};
</script>


// WEBPACK FOOTER //
// Request-invoice.vue?0facb71a